export default {
  app: {
    name: 'Manual Line',
    tagline: 'Sorting log',
  },
  general: {
    add: 'Add',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    close: 'Close',
    back: 'Back',
    yes: 'Yes',
    no: 'No',
    unknown: 'unknown',
    kg: 'kg',
    kg_per_hour: 'kg/h',
    people: 'people',
  },
  errors: {
    generic_error: 'Something went wrong',
    invalid_data: 'Invalid data',
    not_found: 'Not found',
    unauthorized: 'You do not have access',
    duplicate_name: 'Name already exists',
    on_add: 'Error while adding',
    on_edit: 'Error while updating',
  },
  success: {
    add: 'Successfully added',
    edit: 'Successfully updated',
    delete: 'Successfully deleted',
    entry_saved: 'Entry saved',
    logged_in_operator: 'Logged in: {name}',
    logged_in_admin: 'Logged in as administrator',
    pin_changed: 'PIN changed',
    pin_reset: 'PIN for {name} reset',
  },
  lock: {
    locked: 'locked',
    choose_who: 'Choose who you are',
    admin_login: 'Log in as administrator',
    administrator: 'Administrator',
    current_pin: 'Enter current PIN',
    new_pin: 'Enter new PIN',
    confirm_pin: 'Repeat new PIN',
    wrong_pin: 'Wrong PIN, try again',
    pins_dont_match: 'PINs do not match, try again',
  },
  nav: {
    entry: 'New Entry',
    overview: 'Overview',
    log: 'Log',
    registries: 'Registries',
  },
  session: {
    not_logged_in: 'Not logged in',
    operator: 'Logged-in operator',
    administrator: 'Administrator',
    change_pin: 'Change PIN',
    lock: 'Lock screen',
    color_mode: 'Toggle light/dark',
  },
  entry: {
    title: 'New Entry',
    subtitle: 'Log material processed on the line',
    time_frame: 'Time frame',
    time_frame_hint: 'When processing one material runs continuously',
    start: 'Start',
    end: 'End',
    duration: 'Duration (effective)',
    capacity: 'Input capacity',
    utilization: 'Schedule utilization',
    outside_schedule_weekend: '{day} is not part of the regular schedule.',
    outside_schedule_partial: 'Entry partly falls outside the regular schedule ({day} {start}–{end}).',
    material: 'Material processed',
    material_hint: 'Add new ones under Registries',
    qty_in: 'Input quantity',
    qty_in_optional: '(optional, if unknown)',
    qty_in_help: 'If the input is unknown, calculations use the sum of output fractions instead (output is practically always weighed).',
    fractions: 'Output fractions',
    fractions_hint: 'What came out of the processed material',
    add_fraction: 'Add fraction',
    no_fractions: 'No fractions added yet',
    auto_fraction_hint: 'The "=" mark next to a fraction: calculates the difference between input and the other fractions (e.g. for leftover that is not weighed separately).',
    remainder: 'remainder',
    team: 'Team',
    people_on_line: 'People on the line',
    leader: 'Line leader',
    team_members: 'Team (names)',
    team_members_hint: 'Who was on the line',
    no_workers: 'Add new ones under Registries',
    notes: 'Notes',
    notes_optional: 'Optional',
    notes_placeholder: 'e.g. short feeder stoppage at 1pm',
    save: 'Save entry',
  },
  overview: {
    title: 'Overview',
    subtitle: 'For management analysis',
    period_week: 'This week',
    period_month: 'This month',
    period_all: 'All',
    total: 'Total processed',
    total_sub: 'in the selected period',
    count: 'Entries',
    count_sub: 'completed cycles',
    avg_capacity: 'Avg. capacity',
    avg_capacity_sub: 'input / effective time',
    avg_people: 'Avg. people',
    avg_people_sub: 'on the line',
    avg_utilization: 'Avg. schedule utilization',
    avg_utilization_sub: 'averaged over entries when the line ran',
    line_utilization: 'Line time utilization',
    line_utilization_sub: 'work / all available time in period',
    pct_inferred: 'Share of estimated input',
    pct_inferred_sub: 'input was not weighed',
    trend: 'Production trend',
    trend_hint: 'Last 14 days, regardless of the filter above',
    trend_avg: 'Average per day with entries',
    trend_max: 'Highest day',
    trend_empty: 'No entries in the last 14 days.',
    by_material: 'By material (input)',
    by_material_hint: 'Includes estimated input',
    capacity_by_material: 'Capacity by material',
    capacity_by_material_hint: 'Average, kg/h',
    by_fraction: 'By fraction (output)',
    by_leader: 'By line leader',
    by_leader_hint: 'Input (kg)',
    no_data: 'No data',
  },
  days: {
    title: 'Daily overview',
    hint: 'Tick two days to compare them. Expand a row for leaders, workers and individual entries. The percentage next to input and capacity is the change vs. the previous day with entries.',
    empty: 'No entries in the selected period.',
    entries: 'Entries',
    qty_in: 'Input',
    qty_out: 'Output',
    hours: 'Effective hours',
    capacity: 'Capacity',
    utilization: 'Utilization',
    people: 'People',
    leaders: 'Leaders',
    workers: 'Workers',
    materials: 'By material',
    fractions: 'By fraction',
    day_entries: 'Entries of this day',
    details: 'Details',
    select_day: 'Select day for comparison',
    compare_title: 'Day comparison',
    compare_hint: 'Difference = later day − earlier day. A cycle running past midnight is split across days by effective hours.',
    compare_pick: 'Pick one more day to compare.',
    clear_compare: 'Clear selection',
    difference: 'Difference',
    show_more: 'Show older days',
  },
  log: {
    title: 'Log',
    subtitle: 'All recorded entries',
    all: 'All',
    input: 'Input',
    output: 'Output',
    empty: 'No entries for the selected filter.',
    detail_title: 'Entry details',
    date: 'Date',
    time: 'Time',
    material: 'Material',
    duration: 'Duration',
    input_qty: 'Input',
    capacity: 'Capacity',
    utilization: 'Schedule utilization',
    people: 'People on the line',
    leader: 'Line leader',
    team_members: 'Team (names)',
    output_fractions: 'Output fractions',
    total: 'Total',
    no_fractions: 'No fractions recorded',
    notes: 'Notes',
    estimated: 'estimated',
    estimated_tooltip: 'Estimated from the sum of output fractions, because input was not entered.',
  },
  registries: {
    title: 'Registries',
    subtitle: 'Materials, fractions, leaders',
    materials: 'Materials',
    fractions: 'Fractions',
    leaders: 'Line leaders',
    leaders_hint: 'Only an administrator can add',
    leaders_restricted: 'Log in as administrator to add or remove leaders.',
    workers: 'Team (workers)',
    workers_hint: 'Only an administrator can add',
    workers_restricted: 'Log in as administrator to add or remove workers.',
    operators: 'Operators',
    operators_hint: 'PINs are not visible to everyone',
    operators_restricted: 'PINs are not visible to everyone. Log in as administrator to add, remove, or reset a PIN.',
    new_material: 'New material...',
    new_fraction: 'New fraction...',
    new_leader: 'New name...',
    new_worker: 'New full name...',
    new_operator_name: 'Full name...',
    new_operator_pin: 'PIN',
    empty: 'Empty list',
    schedule: 'Schedule (Mon–Fri)',
    schedule_hint: 'Used to suggest entry times, warn outside the schedule, and compute capacity/utilization',
    schedule_weekend_note: 'Saturday and Sunday: no schedule.',
    lunch_break: 'Lunch break',
    lunch_break_hint: 'Same every day. Subtracted from both effective and available time in calculations.',
    weekdays: {
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
    },
  },
}
